// Speedy crown — vector, crisp at any size. "gold": metallic jewelled marketing crown (default). "neon": line-marked stroke outline.
const GOLD_ID = "spd-crown-gold";
const BAND_ID = "spd-crown-band";
const JEWEL_ID = "spd-crown-jewel";

const Jewel = ({ cx, cy }) => {
  const x = Number(cx), y = Number(cy);
  return (
    <g>
      <circle cx={x} cy={y} r="26" fill={`url(#${JEWEL_ID})`} stroke="#FFF3B0" strokeWidth="3" />
      <path d={`M${x} ${y - 15} L${x + 3} ${y - 3} L${x + 15} ${y} L${x + 3} ${y + 3} L${x} ${y + 15} L${x - 3} ${y + 3} L${x - 15} ${y} L${x - 3} ${y - 3} Z`} fill="#FFFFFF" opacity="0.9" />
    </g>
  );
};

export const CrownMark = ({ className = "h-10", animate = true, variant = "gold", stroke = "#FFD84A" }) => {
  const glow = animate ? "crown-glow" : "crown-static";
  if (variant === "neon")
    return (
      <svg viewBox="0 0 590 360" fill="none" className={`${className} w-auto overflow-visible ${glow} ${animate ? "crown-draw" : ""}`} aria-hidden data-testid="crown-mark">
        <g stroke={stroke} strokeWidth="9" strokeLinejoin="round" strokeLinecap="round">
          <path d="M78 228 L40 138 L182 196 L295 68 L408 196 L550 138 L512 228 Z" />
          <circle cx="40" cy="108" r="24" /><circle cx="295" cy="40" r="24" /><circle cx="550" cy="108" r="24" />
          <line x1="295" y1="92" x2="295" y2="222" />
          <rect x="78" y="250" width="434" height="82" rx="6" />
          <line x1="295" y1="250" x2="295" y2="332" />
          <polyline points="112,268 148,291 112,314" /><polyline points="168,268 204,291 168,314" /><polyline points="224,268 260,291 224,314" />
          <line x1="318" y1="274" x2="400" y2="274" /><line x1="318" y1="308" x2="400" y2="308" />
          <line x1="424" y1="274" x2="488" y2="274" /><line x1="424" y1="308" x2="488" y2="308" />
        </g>
      </svg>
    );
  return (
    <svg viewBox="0 0 590 360" className={`${className} w-auto overflow-visible ${glow}`} aria-hidden data-testid="crown-mark">
      <defs>
        <linearGradient id={GOLD_ID} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFF4C2" /><stop offset="0.3" stopColor="#FFD84A" /><stop offset="0.6" stopColor="#DFA62A" /><stop offset="1" stopColor="#7A5210" />
        </linearGradient>
        <linearGradient id={BAND_ID} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#8F6212" /><stop offset="0.5" stopColor="#FFD84A" /><stop offset="1" stopColor="#8F6212" />
        </linearGradient>
        <radialGradient id={JEWEL_ID} cx="0.4" cy="0.35" r="0.7">
          <stop offset="0" stopColor="#FFFFFF" /><stop offset="0.4" stopColor="#FFF7D6" /><stop offset="0.75" stopColor="#FFD84A" /><stop offset="1" stopColor="#A8770F" />
        </radialGradient>
      </defs>
      <path d="M78 228 L40 138 L182 196 L295 68 L408 196 L550 138 L512 228 Z" fill={`url(#${GOLD_ID})`} stroke="#FFE58A" strokeWidth="3" strokeLinejoin="round" />
      <path d="M182 196 L295 68 L295 228 L78 228 Z" fill="#FFFFFF" opacity="0.10" />
      <path d="M295 68 L408 196 L512 228 L295 228 Z" fill="#000000" opacity="0.14" />
      <line x1="295" y1="72" x2="295" y2="228" stroke="#FFF1B8" strokeWidth="3" opacity="0.7" />
      <rect x="78" y="248" width="434" height="84" rx="6" fill={`url(#${BAND_ID})`} stroke="#FFE58A" strokeWidth="3" />
      <g stroke="#0A0A0A" strokeWidth="12" strokeLinejoin="round" strokeLinecap="round" fill="none">
        <line x1="295" y1="248" x2="295" y2="332" />
        <polyline points="112,268 148,290 112,312" /><polyline points="168,268 204,290 168,312" /><polyline points="224,268 260,290 224,312" />
        <line x1="318" y1="274" x2="400" y2="274" /><line x1="318" y1="306" x2="400" y2="306" />
        <line x1="424" y1="274" x2="488" y2="274" /><line x1="424" y1="306" x2="488" y2="306" />
      </g>
      <Jewel cx={40} cy={108} /><Jewel cx={295} cy={40} /><Jewel cx={550} cy={108} />
    </svg>
  );
};

export default CrownMark;
